// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { RadioHierarchyTree } from "@components";
import type { StepProps } from "@components";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";

type OwnProps = $Exact<{
  hierarchy: ?HierarchyTree,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step3HierarchyScope extends React.Component<Props> {
  handleChange = (id: number) => {
    this.props.onChange({ ...this.props.data, id }, true);
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy ? (
            <RadioHierarchyTree
              tree={this.props.hierarchy}
              expanded={[]}
              disabled={false}
              selected={(this.props.data || {}).id}
              onChange={this.handleChange}
              searchable={true}
              searchPlaceholder={this.props.t("HIERARCHY_SCOPE_FIND_DEPARTMENTS")}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default localize()(Step3HierarchyScope);
